// search-index-loader.js
window.loadAllProducts = (function () {
  let loadingPromise = null;

  return function loadAllProducts() {
    // If already loading or loaded, reuse the same promise
    if (loadingPromise) {
      console.log("🔁 loadAllProducts: using existing promise");
      return loadingPromise;
    }

    console.log("🔧 loadAllProducts: fetching /pages/search-index");

    loadingPromise = fetch("/pages/search-index")
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Search index fetch failed: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        if (!Array.isArray(data)) {
          console.error("🚨 Search index: invalid JSON format", data);
          window.allProducts = [];
          return [];
        }
        window.allProducts = data;
        console.log("✅ Full search index loaded:", window.allProducts.length);
        return data;
      })
      .catch((err) => {
        console.error("🚨 Error loading search index:", err);
        window.allProducts = [];
        return [];
      });

    return loadingPromise;
  };
})();
